enum LearningModes {
	flashcards = "flashcards",
	questions = "question",
	essays = "essay",
	quiz = "quiz",
}

export { LearningModes };
